import React from 'react';
import styled from 'astroturf/react';
import { RelatedPaper } from './types';
import _RelatedPapersContainer from "RelatedPapers-RelatedPapersContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=RelatedPapersContainer";
import _SectionHeading from "RelatedPapers-SectionHeading.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=SectionHeading";
import _HeadingText from "RelatedPapers-HeadingText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=HeadingText";
import _RelatedPapersGrid from "RelatedPapers-RelatedPapersGrid.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=RelatedPapersGrid";
import _PaperCard from "RelatedPapers-PaperCard.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=PaperCard";
import _PaperPublication from "RelatedPapers-PaperPublication.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=PaperPublication";
import _PaperTitle from "RelatedPapers-PaperTitle.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=PaperTitle";


const RelatedPapersContainer = /*#__PURE__*/styled("div", null, {
  displayName: "RelatedPapersContainer",
  styles: _RelatedPapersContainer
});

const SectionHeading = /*#__PURE__*/styled("div", null, {
  displayName: "SectionHeading",
  styles: _SectionHeading
});

const HeadingText = /*#__PURE__*/styled("p", null, {
  displayName: "HeadingText",
  styles: _HeadingText
});

const RelatedPapersGrid = /*#__PURE__*/styled("div", null, {
  displayName: "RelatedPapersGrid",
  styles: _RelatedPapersGrid
});

const PaperCard = /*#__PURE__*/styled("a", null, {
  displayName: "PaperCard",
  styles: _PaperCard
});

const PaperPublication = /*#__PURE__*/styled("p", null, {
  displayName: "PaperPublication",
  styles: _PaperPublication
});

const PaperTitle = /*#__PURE__*/styled("p", null, {
  displayName: "PaperTitle",
  styles: _PaperTitle
});

export type RelatedPapersProps = {
  papers: RelatedPaper[];
};

export const RelatedPapers: React.FC<RelatedPapersProps> = ({ papers }) => {
  return (
    <RelatedPapersContainer>
      <SectionHeading>
        <HeadingText>Related papers</HeadingText>
      </SectionHeading>
      <RelatedPapersGrid>
        {papers.map((paper, index) => (
          <PaperCard key={index} href={paper.url}>
            <PaperPublication>{paper.publication}</PaperPublication>
            <PaperTitle>{paper.title}</PaperTitle>
          </PaperCard>
        ))}
      </RelatedPapersGrid>
    </RelatedPapersContainer>
  );
};
